module.exports = __webpack_public_path__ + "media/images/blueShield-3a51df9b1b178fb87f8437afa094cb99.svg";